import { currentTierIIReportingYear } from "encamp-shared/src/constants/tierii";
import { useReport } from "routes/Customer/Chemicals/Report/useReport";

import { useQueryParams } from "./useQueryParams";

/**
 * This hook will return the currently viewed reporting year.
 * If we're in a report, it will know to return the report's reporting year.
 * If we're not in a report, it will look for a reporting year query param, and return that.
 * Otherwise, it will return the current Tier II reporting year.
 * @returns number
 */
export function useSelectedReportingYear(): number {
  const { data } = useReport();

  const {
    filters: { ry },
  } = useQueryParams<{ ry: string }>();

  // First, check if we have a valid reporting year from the report data
  if (data?.tierIIReport.reportingYear !== undefined) {
    return data.tierIIReport.reportingYear;
  }

  // If not, check if we have a valid ry query parameter
  if (ry !== undefined && ry !== "") {
    // ast-grep-ignore: no-unsafe-number-parsing
    const parsedRy = Number(ry);
    if (!isNaN(parsedRy)) {
      return parsedRy;
    }
  }

  // If all else fails, return the current Tier II reporting year
  return currentTierIIReportingYear;
}
